import { useCallback, useEffect, useState } from 'react';
import {
  getWorkspaceId,
  PaymentAccountsMethodType,
  useAppSelector,
  useGetAccountsMutation,
} from '@zonofi/zono-money-store';

export const usePaymentMethods = () => {
  const [getAccountsReq, getAccountsRes] = useGetAccountsMutation();
  const sellerWorkspaceId = useAppSelector(getWorkspaceId);

  const [paymentMethodData, setPaymentMethodData] = useState<
    PaymentAccountsMethodType[]
  >([]);
  const [selectedMethods, setSelectedMethods] = useState<
    Record<string, string | null>
  >({});

  useEffect(() => {
    if (sellerWorkspaceId) {
      getAccountsReq({
        params: {
          sellerWorkspaceId,
          workspaceId: sellerWorkspaceId,
        },
      });
    }
  }, [sellerWorkspaceId]);

  useEffect(() => {
    if (getAccountsRes.isSuccess && getAccountsRes.data) {
      const { upiAccounts = [], bankAccounts = [] } = getAccountsRes.data;
      const newPaymentData: PaymentAccountsMethodType[] = [
        ...upiAccounts.map((upiData) => ({ ...upiData, type: 'upi' as const })),
        ...bankAccounts.map((bankData) => ({
          ...bankData,
          type: 'bank' as const,
        })),
      ];
      setPaymentMethodData(newPaymentData);
    }
  }, [getAccountsRes.data, getAccountsRes.isSuccess]);

  const onPaymentAccountPress = useCallback(
    (item: PaymentAccountsMethodType) => {
      setSelectedMethods((prev) => ({
        ...prev,
        [item.type]: prev[item.type] === item.id ? null : item.id,
      }));
    },
    []
  );

  const isPaymentAccountSelected = useCallback(
    (item: PaymentAccountsMethodType) => selectedMethods[item.type] === item.id,
    [selectedMethods]
  );

  return {
    paymentMethodData,
    isLoading: getAccountsRes?.isLoading || getAccountsRes?.isUninitialized,
    onPaymentAccountPress,
    isPaymentAccountSelected,
    selectedMethods,
  };
};
